var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "800px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [_c("v-icon", [_vm._v("warning")]), _vm._v(" Advertencia\n    ")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("h3", [_vm._v("¿Desea enviar la programación?")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_vm._v("Nota: Esta acción es irreversible")]),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-textarea", {
                        staticClass: "text-field-reducido-border",
                        attrs: {
                          rows: "2",
                          "auto-grow": "",
                          label: "Justificación del envio",
                          rules: _vm.$validate(["required"]),
                          required: "",
                          outline: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.form.observacion,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "observacion", $$v)
                          },
                          expression: "form.observacion"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "success", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.enviarProgramacion()
                    }
                  }
                },
                [_vm._v("\n        Enviar\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c8cd8e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8cd8e1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/EnviarProgramacion.vue
// module id = null
// module chunks = 